import React, { useCallback, useRef } from 'react'
import { useOutsideClicked } from '../../hooks'
import ErrorText from '../error-text'

// Controlled dropdown that anchors below `children` (the trigger).
// Clicks anywhere outside both the trigger and the panel content close it.
// Clicks inside the panel content do NOT close it — useful for combobox /
// autocomplete style UIs where the user keeps interacting with the trigger
// (typing in an input) while the panel stays open.
const DropdownPanel = ({
    isOpen = false,
    onClose,
    content,
    children,
    className = '',
    contentClassName = '',
    isError = false,
    errorMessage = ''
}) => {
    const wrapperRef = useRef(null)

    const handleOutsideClick = useCallback(() => {
        if (isOpen && onClose) onClose()
    }, [isOpen, onClose])

    useOutsideClicked(wrapperRef, handleOutsideClick)

    return (
        <div ref={wrapperRef} className={`bimmatch-dropdown-panel ${isError ? 'bimmatch-dropdown-panel-error' : ''} ${className}`}>
            {children}
            {isOpen && (
                <div className={`bimmatch-dropdown-panel-content ${contentClassName}`}>
                    {content}
                </div>
            )}
            {isError && errorMessage && <ErrorText className='error-message' left message={errorMessage} />}
        </div>
    )
}

export default DropdownPanel
